import iteratively from './itly';

type Itly = typeof iteratively;

type BaseProvided = 'email' | 'user_id' | 'organization_id' | 'device_id';
type ProvidedKeys<Extra extends PropertyKey = never> =
  | BaseProvided
  | Extract<Extra, PropertyKey>;

export const LIFECYCLE_KEYS = [
  'alias',
  'identify',
  'flush',
  'reset',
  'group',
  'load',
  'page',
  'track',
] as const;

type KeysToKeepOriginal = (typeof LIFECYCLE_KEYS)[number] | 'itly';

// Only omit from plain object-ish args (not functions)
type DropInjected<T, Extra extends PropertyKey> =
  T extends Record<string, unknown> ? Omit<T, ProvidedKeys<Extra>> : T;

type DropInjectedFromArgs<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  A extends any[],
  Extra extends PropertyKey,
> = A extends [infer H, ...infer Rest]
  ? [DropInjected<H, Extra>, ...DropInjectedFromArgs<Rest, Extra>]
  : [];

type RewriteFn<F, Extra extends PropertyKey> = F extends (
  ...a: infer A
) => infer R
  ? (...a: DropInjectedFromArgs<A, Extra>) => R
  : F;

/** Generic “slim” view of the SDK. Extra can be 'source' for Copilot. */
export type SlimItly<Extra extends PropertyKey = never> = {
  [K in keyof Itly]: K extends KeysToKeepOriginal
    ? Itly[K]
    : // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Itly[K] extends (...a: any[]) => any
      ? RewriteFn<Itly[K], Extra>
      : Itly[K];
};

export const webItly = iteratively as unknown as SlimItly;
export const copilotItly = iteratively as unknown as SlimItly<'source'>;

export default webItly;
